import { Grid, TextInput, ActionIcon } from "@mantine/core";
import { DatePicker } from '@mantine/dates';
import { IconTrash, IconSquare, IconSquareCheck } from "@tabler/icons";
import * as App from "./../../model/App";

export interface IDeadlineRowProps {
    onDeleteClick: () => void;
    onCompleteClick: () => void;
    onTitleChange: (text: string) => void;
    onDescriptionChange: (text: string) => void;
    onDueDateChange: (date: Date) => void;
    onTitleBlur?: () => void;
    onDueDateBlur?: () => void;
    deadline: App.Data.App.IDeadline;
}

export default function DeadlineRow(props: IDeadlineRowProps) {
    return (
        <Grid>
            <Grid.Col span={1}>
                <ActionIcon onClick={props.onDeleteClick}><IconTrash /></ActionIcon>
            </Grid.Col>

            <Grid.Col span={1}>
                <ActionIcon onClick={props.onCompleteClick}>
                    {props.deadline.isComplete ? <IconSquareCheck color="green" /> : <IconSquare />}
                </ActionIcon>
            </Grid.Col>

            <Grid.Col span={3}>
                <TextInput placeholder="Title" value={props.deadline.title} onBlur={props?.onTitleBlur} onChange={(event) => { props.onTitleChange(event.target.value); }} />
            </Grid.Col>

            <Grid.Col span={4}>
                <TextInput placeholder="Description" value={props.deadline.description} onChange={(event) => { props.onDescriptionChange(event.target.value); }} />
            </Grid.Col>

            <Grid.Col span={3}>
                <DatePicker placeholder="Due date" value={props.deadline.dueDate ? new Date(props.deadline.dueDate) : null} onBlur={props.onDueDateBlur} onChange={props.onDueDateChange} />
            </Grid.Col>
        </Grid>
    );
}